var Alabama = "อลาบามา";
var Alaska = "อะแลสกา";
var Arizona = "แอริโซนา";
var Arkansas = "อาร์คันซอ";
var California = "แคลิฟอร์เนีย";
var Colorado = "โคโลราโด";
var Connecticut = "คอนเนคติคัต";
var Delaware = "เดลาแวร์";
var Florida = "ฟลอริดา";
var Georgia = "จอร์เจีย";
var Hawaii = "ฮาวาย";
var Idaho = "ไอดาโฮ";
var Illinois = "อิลลินอยส์";
var Indiana = "อินเดียนา";
var Iowa = "ไอโอวา";
var Kansas = "แคนซัส";
var Kentucky = "เคนทักกี";
var Louisiana = "หลุยเซียนา";
var Maine = "เมน";
var Maryland = "แมริแลนด์";
var Massachusetts = "แมสซาชูเซตส์";
var Michigan = "มิชิแกน";
var Minnesota = "มินนิโซตา";
var Mississippi = "มิสซิสซิปปี";
var Missouri = "มิสซูรี";
var Montana = "มอนตานา";
var Nebraska = "เนแบรสกา";
var Nevada = "เนวาดา";
var Ohio = "โอไฮโอ";
var Oklahoma = "โอกลาโฮมา";
var Oregon = "ออริกอน";
var Pennsylvania = "เพนซิลเวเนีย";
var Tennessee = "เทนเนสซี";
var Texas = "เท็กซัส";
var Utah = "ยูทาห์";
var Vermont = "เวอร์มอนต์";
var Virginia = "เวอร์จิเนีย";
var Washington = "วอชิงตัน";
var Wisconsin = "วิสคอนซิน";
var Wyoming = "ไวโอมิง";
var USStates = {
	Alabama: Alabama,
	Alaska: Alaska,
	Arizona: Arizona,
	Arkansas: Arkansas,
	California: California,
	Colorado: Colorado,
	Connecticut: Connecticut,
	Delaware: Delaware,
	"District of Columbia (DC)": "ดิสตริกต์ออฟโคลัมเบีย (ดีซี)",
	Florida: Florida,
	Georgia: Georgia,
	Hawaii: Hawaii,
	Idaho: Idaho,
	Illinois: Illinois,
	Indiana: Indiana,
	Iowa: Iowa,
	Kansas: Kansas,
	Kentucky: Kentucky,
	Louisiana: Louisiana,
	Maine: Maine,
	Maryland: Maryland,
	Massachusetts: Massachusetts,
	Michigan: Michigan,
	Minnesota: Minnesota,
	Mississippi: Mississippi,
	Missouri: Missouri,
	Montana: Montana,
	Nebraska: Nebraska,
	Nevada: Nevada,
	"New Hampshire": "นิวแฮมป์เชียร์",
	"New Jersey": "นิวเจอร์ซีย์",
	"New Mexico": "นิวเม็กซิโก",
	"New York": "นิวยอร์ก",
	"North Carolina": "นอร์ทแคโรไลนา",
	"North Dakota": "นอร์ทดาโกตา",
	Ohio: Ohio,
	Oklahoma: Oklahoma,
	Oregon: Oregon,
	Pennsylvania: Pennsylvania,
	"Rhode Island": "โรดไอแลนด์",
	"South Carolina": "เซาท์แคโรไลนา",
	"South Dakota": "เซาท์ดาโคตา",
	Tennessee: Tennessee,
	Texas: Texas,
	Utah: Utah,
	Vermont: Vermont,
	Virginia: Virginia,
	Washington: Washington,
	"West Virginia": "เวสต์เวอร์จิเนีย",
	Wisconsin: Wisconsin,
	Wyoming: Wyoming
};

export { Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware, Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana, Nebraska, Nevada, Ohio, Oklahoma, Oregon, Pennsylvania, Tennessee, Texas, Utah, Vermont, Virginia, Washington, Wisconsin, Wyoming, USStates as default };
